export const checkEnvironment = (env, val) => env.includes(val)
